import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import * as readerConfigQuery from './state/configuration/configuration.selectors';
import { PlayerApiClient } from './player-api/player-api-client.service';
import { ReaderApiClient } from './reader-api/reader-api.client.service';

@Injectable({ providedIn: 'root' })
export class ApiClientSelectorService {
  private readonly apiFlagCheckedSubject = new BehaviorSubject<boolean | null>(null);
  private readonly useReaderApiSubject = new BehaviorSubject<boolean>(
    sessionStorage.getItem('useReaderApi') === 'true',
  );

  readonly apiFlagChecked = this.apiFlagCheckedSubject.asObservable();
  readonly playerApi$ = this.store.pipe(select(readerConfigQuery.getPlayerApi));
  readonly readerApi$ = this.store.pipe(select(readerConfigQuery.getReaderApi));
  readonly useReaderApi$ = this.useReaderApiSubject.asObservable();

  readonly activeApi$: Observable<string | undefined> = combineLatest([
    this.playerApi$,
    this.readerApi$,
    this.useReaderApi$,
  ]).pipe(
    map(([playerApi, readerApi, useReaderApi]) => {
      return useReaderApi ? readerApi : playerApi;
    }),
  );

  constructor(
    private readonly store: Store,
    private readonly playerApiClient: PlayerApiClient,
    private readonly readerApiClient: ReaderApiClient,
  ) {
  }

  setUseReaderApi(enabled: boolean): void {
    if (enabled) {
      sessionStorage.setItem('useReaderApi', 'true');
    }

    this.apiFlagCheckedSubject.next(enabled);
    this.useReaderApiSubject.next(enabled || this.useReaderApiSubject.value);
  }

  getApiClient(): PlayerApiClient | ReaderApiClient {
    return this.useReaderApiSubject.value ? this.readerApiClient : this.playerApiClient;
  }
}
